import React from 'react'

import Tooltip from 'components/tooltips/Tooltip'

type Props = Record<string, never>

const SaltSumInfo: React.FC<Props> = () => {
  return (
    <Tooltip
      content={
        <div>
          <p>
            The <b>EDH Salt Score</b> is a crowd sourced indicator of how salty cards make players in EDH. The data is
            aggregated by EDHREC. &nbsp;
          </p>
          <p>
            The Salt Score is on a scale of 0 to 4. The Salt sum to the total sum of all salt scores of all cards in
            your deck.
          </p>
          <p>Double click on a card or go to its card page to view its individual Salt Score.</p>
          <p>
            <b>Disclaimer:</b> This is not an accurate representation of a deck's power level or even final levels of
            saltiness. It should only be used for casual statistical analysis and should not replace a Rule 0
            conversation.
          </p>
        </div>
      }
    />
  )
}

export default SaltSumInfo
